import { render } from "./CourseLessonsView.vue?vue&type=template&id=2aa89a15&scoped=true"
import script from "./CourseLessonsView.vue?vue&type=script&lang=js"
export * from "./CourseLessonsView.vue?vue&type=script&lang=js"

import "./CourseLessonsView.vue?vue&type=style&index=0&id=2aa89a15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa89a15"]])

export default __exports__